import React from 'react';
import PropTypes from 'prop-types';
import {StyledIconWrapper} from './StyledIconWrapper';

const IconWrapper = ({
  children,
  color,
  ghost = false,
  size = 24,
  rotate = 0,
  ...rest
}) => {

  return (
    <StyledIconWrapper color={color} size={size} rotate={rotate} ghost={ghost} {...rest}>
      {children}
    </StyledIconWrapper>
  );
}

IconWrapper.propTypes = {
  color: PropTypes.string,
  ghost: PropTypes.bool,
}

export default IconWrapper;
